import { Link } from 'react-router-dom'
import { EmptyState, ErrorPanel, Skeleton } from '../components/ui'
import { useResource } from '../hooks/useResource'
import { useApi } from '../lib/api-context'
import { formatDateTime, maskedKey } from '../lib/format'

export function ProjectsPage() {
  const api = useApi()
  const projects = useResource(() => api.listProjects(), [api])

  return (
    <>
      <div className="page-head">
        <div className="page-head__text">
          <h1>Projects</h1>
          <p className="muted">Framer projects you connected with your own API key.</p>
        </div>
        <Link to="/app/projects/new" className="button">
          Connect a project
        </Link>
      </div>

      {projects.loading ? <Skeleton rows={3} /> : null}

      {projects.error ? <ErrorPanel error={projects.error} onRetry={projects.reload} /> : null}

      {projects.data && projects.data.items.length === 0 ? (
        <EmptyState
          title="No projects yet"
          description="Connect a Framer project you own to scan it and export its content."
          action={
            <Link to="/app/projects/new" className="button">
              Connect a project
            </Link>
          }
        />
      ) : null}

      {projects.data && projects.data.items.length > 0 ? (
        <div className="card card--flat">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Project</th>
                <th scope="col">Key</th>
                <th scope="col">Last scan</th>
                <th scope="col" className="table__actions">
                  <span className="sr-only">Actions</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {projects.data.items.map((project) => (
                <tr key={project.id}>
                  <td>
                    <Link to={`/app/projects/${project.id}`} className="step__name">
                      {project.name}
                    </Link>
                    <div className="subtle">{project.framerProjectKey ?? project.framerUrl}</div>
                  </td>
                  <td className="mono">{maskedKey(project.apiKeyLast4)}</td>
                  <td className="muted">
                    {project.lastScanAt ? formatDateTime(project.lastScanAt) : 'Never scanned'}
                  </td>
                  <td className="table__actions">
                    <Link to={`/app/projects/${project.id}`} className="button button--secondary">
                      Open
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </>
  )
}
